/* eslint-disable */
import React, { useState, useEffect, useContext } from "react";

import { useParams } from "react-router-dom";

//import translation function for language translation
import { useTranslation } from "react-i18next";

import { Link } from "react-router-dom";

/*import url and gateway methods */
import { getData } from "utils/Gateway";
import * as url from "urlhelpers/UrlHelper";

//import context
import { GlobalProvider } from "context/GlobalContext";
import UserProfileTabBreadCrumb from "../BreadCrumb/UserProfileTabBreadCrumb";

import { parseAdjust } from "helpers/ParseAdjust";

import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";

const localizer = momentLocalizer(moment);

const CalenderTab = ({ reloadCalender, setReloadCalender, userData, activeTab }) => {
  /* ========== get user id from url params ========= */
  const params = useParams();
  const token = localStorage.getItem("token"); // for token
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  //import conext
  const { reloadCalendarEvents, setReloadCalendarEvents, setEditCalendarData } =
    useContext(GlobalProvider);

  // default user data ------------------------------------
  const [calendarData, setCalendarData] = useState([]);
  const [responseReceived, setResponseReceived] = useState(false);
  const [holidayResponseReceived, setHolidayResponseReceived] = useState(false);

  const [isMassEdit, setIsMassEdit] = useState(false);
  const [editedIdsArr, setEditedIdsArr] = useState([]);
  const [isLoading, setIsLoading] = useState(false); // State for loading placeholder

  const { t, i18n } = useTranslation(); // translation, language selection

  // get json data about date ------------------------------
  const currentYear = new Date().getFullYear();

  // function for get all calendar data
  const getAllCalendarData = async () => {
    try {
      setIsLoading(true); // Show loading placeholder
      let requestUrl =
        url.API_BASEURL +
        url.API_GET_ALL_SCHEDULE +
        `?token=${token}&user=${params.id}`;

      console.log("Url of calender list========>", requestUrl);

      const response = await getData(requestUrl);

      console.log(`response in calender list ==============>`, response.data);

      if (response.status) {
        const holidayScheduleData = await getHolidayCalendarData();

        const userScheduleData = response.data;

        const allData = [...holidayScheduleData, ...userScheduleData];

        setCalendarData(allData);

        setResponseReceived(true);
      }
    } catch (error) {
      console.error(error.message);
    } finally {
      setIsLoading(false); // Hide loading placeholder
    }
  };

  // function for get all calendar data
  const getHolidayCalendarData = async () => {
    let holidaySchedules = [];

    try {
      let requestUrl =
        url.API_BASEURL + url.API_GET_ALL_HOLIDAY_SCHEDULE + `?token=${token}`;

      const response = await getData(requestUrl);

      console.log(
        `response of holiday calendar list ==============>`,
        response.data
      );
      if (response.status) {
        if (response.data) {
          holidaySchedules = response.data;
        }

        return holidaySchedules;
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  // set response to match kendo scheduler event schema --------------------------------
  const kendoCalendarData = calendarData.map((dataItem) => ({
    id: dataItem._id,
    start: parseAdjust(dataItem.start, dataItem.starttime),
    end: parseAdjust(dataItem.end, dataItem.endtime),
    isAllDay: false,
    title: dataItem.title,
    name: dataItem.name,
    description: dataItem.description,
    ownerId: dataItem.availability,
    date: dataItem.date,
    availability: dataItem.availability,
    starttime: dataItem.starttime,
    endtime: dataItem.endtime,
    clientid: dataItem.clientid,
    conceptid: dataItem.conceptid,
    reserveid: dataItem.reserveid,
    shift: dataItem.shift,
  }));

  /*---------- Handel Edit Calendar Schedule data ------------*/
  const scheduleItemHandler = (event) => {
    const dataItem = event.resource;

    console.log("props.dataItem", dataItem);

    if (dataItem.availability) {
      if (isMassEdit) {
        if (editedIdsArr.includes(dataItem.id)) {
          const updatedArr = editedIdsArr.filter(
            (item) => item.toString() !== dataItem.id.toString()
          );
          setEditedIdsArr(updatedArr);
        } else {
          setEditedIdsArr([...editedIdsArr, dataItem.id]);
        }
      } else {
        setEditCalendarData([dataItem.id]);

        // if dataItem.reserveid is not null then show details popup
        // else show edit popup

        if (dataItem.reserveid) {
          // show viewReserveSchedulePopup modal
          const viewReserveSchedulePopup = new window.bootstrap.Modal(
            document.getElementById("viewReserveSchedulePopup")
          );
          viewReserveSchedulePopup.show();
        } else {
          const offcanvas = new window.bootstrap.Offcanvas(
            document.getElementById("editSchedulePopup")
          );
          offcanvas.show();
        }
      }
    }
  };

  //function for trigger popup for mass edit
  const massEditHandler = () => {
    if (editedIdsArr.length > 0) {
      setEditCalendarData(editedIdsArr);
      const offcanvas = new window.bootstrap.Offcanvas(
        document.getElementById("editSchedulePopup")
      );
      offcanvas.show();
      setIsMassEdit(false);
      setEditedIdsArr([]);
    }
  };

  const eventStyleGetter = (event) => {
    const dataItem = event.resource;
    let background;
    if (editedIdsArr.includes(dataItem && dataItem.id)) {
      background = "grey";
    } else if (dataItem && dataItem.availability == "1") {
      background = "#32CD32";
    } else if (dataItem && dataItem.availability == "0") {
      background = "#FF0000";
    } else {
      background = "#FA05E1";
    }
    return { style: { backgroundColor: background } };
  };

  /* hook to reload list */
  useEffect(() => {
    if (reloadCalendarEvents) {
      getAllCalendarData();
      getHolidayCalendarData();
      setReloadCalendarEvents(false);

      console.log("calendarData >>>", calendarData);
    }
  }, [reloadCalendarEvents]);

  useEffect(() => {
    if (responseReceived === false) {
      getAllCalendarData();

      console.log("calendarData 1 >>>", calendarData);
    }
  }, [responseReceived]);

  return (
    <div className="profile_tabInnr">
      <UserProfileTabBreadCrumb moduleName="Calender" userData={userData} />

      {/* ------ calendar description and add calendar icon section start ------ */}
      <div className="calender_srch_top mb-3">
        <div className="d-flex align-items-center gap-2">
          <p className="mb-0">M : {t("Morning")}</p>
          <p className="mb-0">E : {t("Evening")}</p>
        </div>

        {userInfo?.role?.name == "admin" ||
        userInfo?.role?.name == "manager" ? (
          <div className="ms-auto d-flex gap-1 align-items-center">
            <div className="form-check ">
              <input
                className="form-check-input"
                type="checkbox"
                id="saveAsReserveTemplate"
                checked={isMassEdit}
                onChange={(e) => setIsMassEdit(e.target.checked)}
              />
              <p
                className="text-primary fw-medium"
                htmlFor="saveAsReserveTemplate"
              >
                {t("Update Mutiple Recods")}
              </p>
            </div>
            {isMassEdit && (
              <button className="btn btn-primary" onClick={massEditHandler}>
                {t("Done Selection")}
              </button>
            )}
          </div>
        ) : null}

        {/* ---- add calendar icon ---- */}
        {userInfo?.role?.name == "admin" ||
        userInfo?.role?.name == "manager" ? (
          <div className="calender_addBtn ms-2">
            <Link
              to="#saveSchedulePopup"
              data-bs-toggle="offcanvas"
              className="btn btn-primary"
            >
              <i className="material-icons-outlined">add</i>
            </Link>
          </div>
        ) : null}
      </div>
      {/* ------ calendar description and add calendar icon section end ------ */}

      {isLoading && (
        <div className="loading-placeholder d-flex align-items-center justify-content-center">
          <div className="spinner-border text-primary me-2" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <span>Loading, please wait...</span>
        </div>
      )} {/* Updated loading placeholder */}

      <div className="calender_info">
        <Calendar
          localizer={localizer}
          events={(kendoCalendarData || []).map((ev) => ({
            title: ev.title || "",
            start: new Date(ev.start),
            end: new Date(ev.end),
            resource: ev,
          }))}
          startAccessor="start"
          endAccessor="end"
          style={{ height: 600 }}
          views={["month", "week", "day", "agenda"]}
          defaultView="month"
          onSelectEvent={scheduleItemHandler}
          eventPropGetter={eventStyleGetter}
        />
      </div>
    </div>
  );
};

export default CalenderTab;
